import React from "react"
import {FieldManagementPreviewProps} from "../../../render/management-preview";
import FieldMultiselect_Pill from "../components/pill";


export default function FieldMultiselect_ManagementPreview(props: FieldManagementPreviewProps) {

    let options

    if (props.field.getOptions() && props.field.getOptions().length>0) {
        options = _.slice(props.field.options, 0, 2);
    } else {
        // new field
        options = [{ label: 'Option 1', value: 'test-id1' }, { label: 'Option 2', value: 'test-id2' }];
    }

    return (
        <div className={Classes("ui5-txt-default", "fl-ac", "max-w-300", "fl-wrap", "m-t-4", "m-b-4")}>
            {_.map(options, (option) => {
                return <FieldMultiselect_Pill key={option.value} className="m-r-10 m-t-4 m-b-4" option={option}/>
            })}
        </div>
    )


}